// Also true without matchMedia (e.g. jsdom in tests, where the property can
// exist but not be a function): exit animations there would never end,
// leaving closed menus and badges mounted
export const prefersReducedMotion = () =>
    typeof window.matchMedia !== "function" ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
